import tinymce, { initTinyMCE } from "../helper/tinymce";

document.addEventListener("DOMContentLoaded", () => {
  const form = document.querySelector('form[name="kampagne"]');
  if (!form) {
    return;
  }

  const editButton = document.getElementById("editButton");
  const saveButton = document.getElementById("saveButton");
  const cancelButton = document.getElementById("cancelButton");
  const prizesTabItem = document.getElementById("prizesTabItem");
  const typSelect = document.getElementById("typ");

  // Selektiert alle relevanten Formularfelder
  const formElements = form.querySelectorAll(
    'input[type="text"], input[type="number"], input[data-datepicker], textarea, select',
  );

  // Elemente für das Tracking
  const facebookTrackingDisplay = document.getElementById("facebookTrackingDisplay");
  const facebookTrackingEdit = document.getElementById("facebookTrackingEdit");
  const facebookTrackingCheckboxInput = document.getElementById("facebookTrackingCheckboxInput");

  const googleTrackingDisplay = document.getElementById("googleTrackingDisplay");
  const googleTrackingEdit = document.getElementById("googleTrackingEdit");
  const googleTrackingCheckboxInput = document.getElementById("googleTrackingCheckboxInput");

  const studiopartnerTagDisplay = document.getElementById("studiopartnerTagDisplay");
  const studiopartnerTagEdit = document.getElementById("studiopartnerTagEdit");
  const studiopartnerTagCheckboxInput = document.getElementById("studiopartnerTagInput");

  // Elemente für den Umfrage-Footer
  const surveyFooterDisplay = document.getElementById("surveyFooterDisplay");
  const surveyFooterEdit = document.getElementById("surveyFooterEdit");
  const footerTextarea = document.getElementById("footer");
  let footerEditorInitialized = false;

  function ensureFooterEditor() {
    if (!footerTextarea || footerEditorInitialized) return;
    footerEditorInitialized = true;
    initTinyMCE("#footer", { min_height: 260 });
  }

  function setFormEditable(isEditable) {
    formElements.forEach((el) => (el.disabled = !isEditable));
    if (editButton) {
      if (isEditable) editButton.classList.add("d-none");
      else editButton.classList.remove("d-none");
    }
    if (saveButton) {
      if (isEditable) saveButton.classList.remove("d-none");
      else saveButton.classList.add("d-none");
    }
    if (cancelButton) {
      if (isEditable) cancelButton.classList.remove("d-none");
      else cancelButton.classList.add("d-none");
    }

    // Facebook Tracking steuern
    if (facebookTrackingDisplay)
      facebookTrackingDisplay.style.display = isEditable ? "none" : "block";
    if (facebookTrackingEdit) facebookTrackingEdit.style.display = isEditable ? "block" : "none";
    if (facebookTrackingCheckboxInput) {
      facebookTrackingCheckboxInput.disabled = !isEditable;
    }

    // Google Tracking steuern
    if (googleTrackingDisplay) googleTrackingDisplay.style.display = isEditable ? "none" : "block";
    if (googleTrackingEdit) googleTrackingEdit.style.display = isEditable ? "block" : "none";
    if (googleTrackingCheckboxInput) {
      googleTrackingCheckboxInput.disabled = !isEditable;
    }

    // studiopartner Tracking steuern
    if (studiopartnerTagDisplay)
      studiopartnerTagDisplay.style.display = isEditable ? "none" : "block";
    if (studiopartnerTagEdit) studiopartnerTagEdit.style.display = isEditable ? "block" : "none";
    if (studiopartnerTagCheckboxInput) {
      studiopartnerTagCheckboxInput.disabled = !isEditable;
    }

    // Umfrage-Footer steuern
    if (surveyFooterDisplay) surveyFooterDisplay.style.display = isEditable ? "none" : "block";
    if (surveyFooterEdit) surveyFooterEdit.style.display = isEditable ? "block" : "none";
    if (isEditable && footerTextarea) {
      ensureFooterEditor();
    }

    // Logo Buttons steuern
    const logoMediaBtn = document.getElementById("campaign-logo-media-btn");
    const logoClearBtn = document.getElementById("campaign-logo-clear-btn");
    if (logoMediaBtn) logoMediaBtn.disabled = !isEditable;
    if (logoClearBtn) logoClearBtn.disabled = !isEditable;
  }

  function checkPrizesTabVisibility() {
    if (!typSelect) return;
    if (prizesTabItem) {
      // AKTION is the value for "Aktion"
      if (typSelect.value === "AKTION") {
        prizesTabItem.style.display = "block";
      } else {
        prizesTabItem.style.display = "none";
      }
    }
    const surveyFooterCardCol = document.getElementById("surveyFooterCardCol");
    if (surveyFooterCardCol) {
      surveyFooterCardCol.style.display = typSelect.value === "UMFRAGE" ? "" : "none";
    }
  }

  // Initialer Zustand: Formular ist nicht bearbeitbar
  setFormEditable(false);
  checkPrizesTabVisibility();

  if (editButton) {
    editButton.addEventListener("click", () => {
      setFormEditable(true);
    });
  }

  if (cancelButton) {
    cancelButton.addEventListener("click", () => {
      form.reset();
      if (footerTextarea && typeof tinymce?.get === "function") {
        const editorInstance = tinymce.get("footer");
        if (editorInstance && typeof editorInstance.setContent === "function") {
          editorInstance.setContent(footerTextarea.defaultValue || "");
        }
      }
      setFormEditable(false);
      // Re-check visibility after reset (in case type changed)
      setTimeout(() => {
        checkPrizesTabVisibility();
        updateCampaignLogoPreview();
      }, 50);
    });
  }

  form.addEventListener("submit", () => {
    if (typeof tinymce?.triggerSave === "function") {
      tinymce.triggerSave();
    }
  });

  function normalizeMediaUrl(url) {
    if (!url || typeof url !== "string") return "";
    url = url.trim();
    if (!url) return "";
    if (
      url.startsWith("http://") ||
      url.startsWith("https://") ||
      url.startsWith("data:") ||
      url.startsWith("/")
    ) {
      return url;
    }
    return "https://media.cs-erfolg.de/" + url;
  }

  function updateCampaignLogoPreview() {
    const logoInput = document.getElementById("logo");
    const logoPreview = document.getElementById("campaign-logo-preview");
    const logoPreviewWrap = document.getElementById("campaign-logo-preview-wrap");
    if (!logoInput || !logoPreview || !logoPreviewWrap) return;
    const rawVal = logoInput.value?.trim();
    if (rawVal) {
      const normalized = normalizeMediaUrl(rawVal);
      if (logoInput.value !== normalized) {
        logoInput.value = normalized;
      }
      logoPreview.src = normalized;
      logoPreviewWrap.style.display = "";
    } else {
      logoPreview.src = "";
      logoPreviewWrap.style.display = "none";
    }
  }

  function setupCampaignLogo() {
    const logoInput = document.getElementById("logo");
    const logoMediaBtn = document.getElementById("campaign-logo-media-btn");
    const logoClearBtn = document.getElementById("campaign-logo-clear-btn");

    if (logoInput) {
      logoInput.addEventListener("input", updateCampaignLogoPreview);
      logoInput.addEventListener("change", updateCampaignLogoPreview);
    }

    if (logoClearBtn && logoInput) {
      logoClearBtn.addEventListener("click", () => {
        logoInput.value = "";
        updateCampaignLogoPreview();
      });
    }

    if (logoMediaBtn && logoInput) {
      logoMediaBtn.addEventListener("click", () => {
        if (typeof window.MediaModal !== "function") {
          console.error("MediaModal is not loaded.");
          return;
        }
        if (!window._campaignMediaModal) {
          window._campaignMediaModal = new window.MediaModal(true);
        }
        window._campaignMediaModal.open({
          targetInput: "#logo",
          callback: (url) => {
            if (url) {
              logoInput.value = url;
              updateCampaignLogoPreview();
            }
          },
        });
      });
    }
  }
  setupCampaignLogo();

  if (typSelect) {
    typSelect.addEventListener("change", checkPrizesTabVisibility);
  }

  // Link kopieren Funktion
  const linkInput = document.getElementById("kampagnenLink");
  if (linkInput && linkInput.value && linkInput.value.startsWith("/")) {
    linkInput.value = window.location.origin + linkInput.value;
  }

  window.copyLink = function () {
    const input = document.getElementById("kampagnenLink");
    if (!input) return;
    navigator.clipboard.writeText(input.value).then(
      () => {
        alert("Link in Zwischenablage kopiert!");
      },
      () => {
        alert("Fehler beim Kopieren des Links.");
      },
    );
  };

  // Tab-Aktivierung basierend auf URL-Hash
  const hash = window.location.hash;
  const activeTabInput = document.getElementById("activeTabInput");

  if (hash) {
    const triggerEl = document.querySelector(`a[data-bs-target="${hash}"]`);
    if (triggerEl) {
      if (typeof bootstrap !== "undefined" && bootstrap.Tab) {
        const tab = new bootstrap.Tab(triggerEl);
        tab.show();
      } else {
        triggerEl.click();
      }
      if (activeTabInput) activeTabInput.value = hash.substring(1);
    }
  }

  // Tab-Wechsel beobachten
  const tabLinks = document.querySelectorAll('a[data-bs-toggle="tab"]');
  tabLinks.forEach((link) => {
    link.addEventListener("shown.bs.tab", (e) => {
      if (activeTabInput) {
        const target = e.target.getAttribute("data-bs-target");
        if (target) activeTabInput.value = target.substring(1);
      }
    });
  });

  // Prizes Management Logic
  const prizesCheckAll = document.getElementById("prizes-check-all");
  const batchActionSelect = document.getElementById("prizes-batch-action");
  const batchActionBtn = document.getElementById("prizes-batch-btn");
  const prizesFilter = document.getElementById("prizes-filter");

  if (prizesCheckAll) {
    prizesCheckAll.addEventListener("change", function () {
      const prizeCheckboxes = document.querySelectorAll(".prize-check");
      prizeCheckboxes.forEach((cb) => (cb.checked = this.checked));
    });
  }

  if (batchActionBtn) {
    batchActionBtn.addEventListener("click", function () {
      const action = batchActionSelect.value;
      if (!action) return;

      const selectedIds = Array.from(document.querySelectorAll(".prize-check:checked"))
        .filter((cb) => {
          const row = cb.closest(".prize-row");
          return row && row.style.display !== "none";
        })
        .map((cb) => cb.value);
      if (selectedIds.length === 0) {
        alert("Bitte wählen Sie mindestens einen Gewinn aus.");
        return;
      }

      if (action === "1") {
        if (!confirm("Sind Sie sicher, dass Sie die ausgewählten Gewinne löschen möchten?")) return;

        const form = document.createElement("form");
        form.method = "POST";
        form.action = window.location.pathname + "/prizes/batch";

        const actionInput = document.createElement("input");
        actionInput.type = "hidden";
        actionInput.name = "action";
        actionInput.value = action;
        form.appendChild(actionInput);

        selectedIds.forEach((id) => {
          const input = document.createElement("input");
          input.type = "hidden";
          input.name = "ids";
          input.value = id;
          form.appendChild(input);
        });

        const mainFormCsrf = document.querySelector('input[name="_csrf"]');
        if (mainFormCsrf) {
          const csrfInput = mainFormCsrf.cloneNode(true);
          form.appendChild(csrfInput);
        }

        document.body.appendChild(form);
        form.submit();
      }
    });
  }

  if (prizesFilter) {
    const titles = new Set();
    document.querySelectorAll(".prize-title").forEach((el) => titles.add(el.textContent.trim()));
    Array.from(titles)
      .sort()
      .forEach((title) => {
        const option = document.createElement("option");
        option.value = title;
        option.textContent = title;
        prizesFilter.appendChild(option);
      });

    prizesFilter.addEventListener("change", function () {
      const filterValue = this.value;
      document.querySelectorAll(".prize-row").forEach((row) => {
        const title = row.querySelector(".prize-title").textContent.trim();
        if (filterValue === "" || title === filterValue) {
          row.style.display = "";
        } else {
          row.style.display = "none";
        }
      });
    });
  }

  document.querySelectorAll(".sortable").forEach((header) => {
    header.addEventListener("click", function () {
      const sortKey = this.dataset.sort;
      const order = this.dataset.order === "asc" ? "desc" : "asc";
      this.dataset.order = order;

      document.querySelectorAll(".sortable i").forEach((i) => (i.className = "fas fa-sort ms-1"));
      this.querySelector("i").className = `fas fa-sort-${order === "asc" ? "up" : "down"} ms-1`;

      const rows = Array.from(document.querySelectorAll(".prize-row"));
      rows.sort((a, b) => {
        let valA, valB;
        if (sortKey === "title") {
          valA = a.querySelector(".prize-title").textContent.trim().toLowerCase();
          valB = b.querySelector(".prize-title").textContent.trim().toLowerCase();
        } else if (sortKey === "status") {
          valA = parseInt(a.querySelector(".prize-status").dataset.status);
          valB = parseInt(b.querySelector(".prize-status").dataset.status);
        }

        if (valA < valB) return order === "asc" ? -1 : 1;
        if (valA > valB) return order === "asc" ? 1 : -1;
        return 0;
      });

      const tbody = document.querySelector("#prizes-table tbody");
      rows.forEach((row) => tbody.appendChild(row));
    });
  });

  // Campaign Performance Chart with Dynamic Range Filtering
  const campaignPerformanceChartEl = document.getElementById("campaignPerformanceChart");
  if (campaignPerformanceChartEl && typeof window.Chart !== "undefined") {
    let campaignId = null;
    const idInput =
      document.querySelector('input[name="id"]') || document.getElementById("survey-campaign-id");
    if (idInput && idInput.value) {
      campaignId = idInput.value;
    } else {
      const pathMatch = window.location.pathname.match(/\/campaigns\/(\d+)/);
      if (pathMatch) {
        campaignId = pathMatch[1];
      } else if (form) {
        const formAction = form.getAttribute("action");
        if (formAction) {
          const m = formAction.match(/\/(\d+)(?:\?|$)/);
          if (m) campaignId = m[1];
          else campaignId = formAction.split("?")[0].split("/").filter(Boolean).pop();
        }
      }
    }

    if (campaignId) {
      let performanceChart = null;
      let currentRange = "7d";

      const renderPerformanceChart = (data) => {
        const ctx = campaignPerformanceChartEl.getContext("2d");
        const isDarkMode = document.documentElement.getAttribute("data-bs-theme") === "dark";
        const gridColor = isDarkMode ? "rgba(255, 255, 255, 0.08)" : "#f1f5f9";
        const tickColor = isDarkMode ? "#94a3b8" : "#64748b";
        const legendColor = isDarkMode ? "#e2e8f0" : "#475569";

        let gradientAufrufe = "rgba(79, 70, 229, 0.12)";
        let gradientKontakte = "rgba(16, 185, 129, 0.12)";
        if (ctx) {
          const grad1 = ctx.createLinearGradient(0, 0, 0, 300);
          grad1.addColorStop(0, "rgba(79, 70, 229, 0.28)");
          grad1.addColorStop(1, "rgba(79, 70, 229, 0.0)");
          gradientAufrufe = grad1;

          const grad2 = ctx.createLinearGradient(0, 0, 0, 300);
          grad2.addColorStop(0, "rgba(16, 185, 129, 0.28)");
          grad2.addColorStop(1, "rgba(16, 185, 129, 0.0)");
          gradientKontakte = grad2;
        }

        if (performanceChart) {
          performanceChart.data.labels = data.labels || [];
          performanceChart.data.datasets[0].data = data.aufrufe || [];
          performanceChart.data.datasets[0].backgroundColor = gradientAufrufe;
          performanceChart.data.datasets[1].data = data.kontakte || [];
          performanceChart.data.datasets[1].backgroundColor = gradientKontakte;
          performanceChart.options.scales.y.grid.color = gridColor;
          performanceChart.options.scales.y.ticks.color = tickColor;
          performanceChart.options.scales.x.ticks.color = tickColor;
          performanceChart.options.plugins.legend.labels.color = legendColor;
          performanceChart.update();
          return;
        }

        performanceChart = new window.Chart(campaignPerformanceChartEl, {
          type: "line",
          data: {
            labels: data.labels || [],
            datasets: [
              {
                label: "Aufrufe",
                data: data.aufrufe || [],
                borderColor: "#4f46e5",
                backgroundColor: gradientAufrufe,
                borderWidth: 2.5,
                fill: true,
                tension: 0.35,
                pointRadius: 3.5,
                pointBackgroundColor: "#ffffff",
                pointBorderColor: "#4f46e5",
                pointBorderWidth: 2,
                pointHoverRadius: 6,
                pointHoverBackgroundColor: "#4f46e5",
                pointHoverBorderColor: "#ffffff",
                pointHoverBorderWidth: 2,
              },
              {
                label: "Kontakte",
                data: data.kontakte || [],
                borderColor: "#10b981",
                backgroundColor: gradientKontakte,
                borderWidth: 2.5,
                fill: true,
                tension: 0.35,
                pointRadius: 3.5,
                pointBackgroundColor: "#ffffff",
                pointBorderColor: "#10b981",
                pointBorderWidth: 2,
                pointHoverRadius: 6,
                pointHoverBackgroundColor: "#10b981",
                pointHoverBorderColor: "#ffffff",
                pointHoverBorderWidth: 2,
              },
            ],
          },
          options: {
            responsive: true,
            maintainAspectRatio: false,
            interaction: {
              mode: "index",
              intersect: false,
            },
            plugins: {
              legend: {
                position: "top",
                align: "end",
                labels: {
                  usePointStyle: true,
                  pointStyle: "circle",
                  padding: 16,
                  font: {
                    family: "'Plus Jakarta Sans', system-ui, sans-serif",
                    size: 13,
                    weight: "600",
                  },
                  color: legendColor,
                },
              },
              tooltip: {
                backgroundColor: "#0f172a",
                titleColor: "#f8fafc",
                bodyColor: "#f1f5f9",
                titleFont: {
                  family: "'Plus Jakarta Sans', system-ui, sans-serif",
                  size: 13,
                  weight: "600",
                },
                bodyFont: {
                  family: "'Plus Jakarta Sans', system-ui, sans-serif",
                  size: 12,
                  weight: "500",
                },
                padding: 12,
                cornerRadius: 10,
                boxPadding: 6,
                usePointStyle: true,
              },
            },
            scales: {
              x: {
                grid: {
                  display: false,
                },
                ticks: {
                  font: {
                    family: "'Plus Jakarta Sans', system-ui, sans-serif",
                    size: 12,
                    weight: "500",
                  },
                  color: tickColor,
                },
              },
              y: {
                beginAtZero: true,
                border: {
                  dash: [4, 4],
                },
                grid: {
                  color: gridColor,
                },
                ticks: {
                  precision: 0,
                  font: {
                    family: "'Plus Jakarta Sans', system-ui, sans-serif",
                    size: 12,
                    weight: "500",
                  },
                  color: tickColor,
                },
              },
            },
          },
        });
      };

      const loadPerformanceData = (range = "7d") => {
        currentRange = range;
        fetch(`/api/campaigns/${campaignId}/performance?range=${encodeURIComponent(range)}`)
          .then((response) => response.json())
          .then((data) => {
            renderPerformanceChart(data);
          })
          .catch((error) => console.error("Error fetching campaign performance:", error));
      };

      // Range Selector Buttons
      const rangeButtons = document.querySelectorAll(
        ".performance-range-selector button[data-range]",
      );
      rangeButtons.forEach((btn) => {
        btn.addEventListener("click", () => {
          rangeButtons.forEach((b) => b.classList.remove("active"));
          btn.classList.add("active");
          loadPerformanceData(btn.dataset.range);
        });
      });

      // Initial load
      loadPerformanceData("7d");

      // Theme toggle reactivity
      window.addEventListener("themeChanged", () => {
        if (performanceChart) {
          loadPerformanceData(currentRange);
        }
      });
    }
  }

  // Metadata Collapse Chevron Rotation
  const collapseMetadata = document.getElementById("collapseMetadata");
  const metadataChevron = document.getElementById("metadataChevron");
  if (collapseMetadata && metadataChevron) {
    collapseMetadata.addEventListener("show.bs.collapse", () => {
      metadataChevron.style.transform = "rotate(180deg)";
    });
    collapseMetadata.addEventListener("hide.bs.collapse", () => {
      metadataChevron.style.transform = "rotate(0deg)";
    });
  }

  // Sidebar Collapse / Expand Toggle
  const toggleSidebarBtn = document.getElementById("toggleCampaignSidebarBtn");
  const mainCol = document.getElementById("campaignMainCol");
  const sideCol = document.getElementById("campaignSideCol");
  const sidebarIcon = document.getElementById("toggleCampaignSidebarIcon");
  const sidebarText = document.getElementById("toggleCampaignSidebarText");

  function setSidebarCollapsed(collapsed) {
    if (!mainCol || !sideCol) return;
    if (collapsed) {
      mainCol.classList.remove("col-xl-9");
      mainCol.classList.add("col-xl-12");
      sideCol.classList.add("d-none");
      if (sidebarIcon) {
        sidebarIcon.classList.remove("bi-layout-sidebar-reverse");
        sidebarIcon.classList.add("bi-layout-sidebar-inset-reverse");
      }
      if (sidebarText) sidebarText.textContent = "Seitenleiste ausklappen";
      if (toggleSidebarBtn) {
        toggleSidebarBtn.setAttribute("title", "Seitenleiste ausklappen");
        toggleSidebarBtn.setAttribute("aria-label", "Seitenleiste ausklappen");
      }
    } else {
      mainCol.classList.remove("col-xl-12");
      mainCol.classList.add("col-xl-9");
      sideCol.classList.remove("d-none");
      if (sidebarIcon) {
        sidebarIcon.classList.remove("bi-layout-sidebar-inset-reverse");
        sidebarIcon.classList.add("bi-layout-sidebar-reverse");
      }
      if (sidebarText) sidebarText.textContent = "Seitenleiste einklappen";
      if (toggleSidebarBtn) {
        toggleSidebarBtn.setAttribute("title", "Seitenleiste einklappen");
        toggleSidebarBtn.setAttribute("aria-label", "Seitenleiste einklappen");
      }
    }
    localStorage.setItem("campaign_details_sidebar_collapsed", collapsed ? "true" : "false");
    setTimeout(() => {
      window.dispatchEvent(new Event("resize"));
    }, 100);
  }

  if (toggleSidebarBtn) {
    const savedState =
      typeof localStorage !== "undefined" &&
      localStorage &&
      localStorage.getItem("campaign_details_sidebar_collapsed") === "true";
    if (savedState) {
      setSidebarCollapsed(true);
    }
    toggleSidebarBtn.addEventListener("click", () => {
      const isCurrentlyCollapsed = sideCol && sideCol.classList.contains("d-none");
      setSidebarCollapsed(!isCurrentlyCollapsed);
    });
  }
});

document.querySelectorAll(".survey-reset").forEach((element) => {
  element.addEventListener("click", (e) => {
    const url = e.currentTarget.href;
    e.preventDefault();

    if (typeof cs !== "undefined" && cs.Swal) {
      cs.Swal.mixin({
        customClass: { confirmButton: "btn btn-danger me-3", cancelButton: "btn btn-secondary" },
        buttonsStyling: false,
      })
        .fire({
          title: "Sicher?",
          text: "Alle bisherigen Antworten werden unwiderruflich gelöscht.",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Ja, löschen!",
          cancelButtonText: "Abbrechen",
        })
        .then((result) => {
          if (result.isConfirmed) window.location.href = url;
        });
    }
  });
});
